import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Orgon';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/bvdz-fonts/Orgon-RegWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 700;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/bvdz-fonts/Orgon-BolWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 800;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/bvdz-fonts/Orgon-XBolWeb.woff');
    }

    * {
        box-sizing: border-box;
    }

    html, body {
        height: 100%;
    }

    body {
        font-family: 'Orgon', sans-serif;
        margin: 0;
        padding: 0;
    }

    #root {
        height: 100%;
    }

    button {
        font-family: inherit;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    li {
        list-style-type: none;
    }
`;
